import React from "react";
import RelectAndIntegrate1Image from "../../../../Assets/Images/self-about.png";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";

const styles = {
  pageWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "631px", 
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  image: {
    width: "100%",
    height: "152px",
  },
  contentDescription: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "30px"
  },
  icon: {
    width: "68px",
    height: "68px",
  },
  text: {
    fontFamily: "Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "35px",
    color: "#00577D",
    textAlign: "center",
  },
  footer: {
    position: "absolute",
    bottom: "0px",
    borderTop: "1px solid #426B88",
    display: "flex",
    flexDirection: "row",
    width: "571px",
    gap: "30px",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    boxSizing: "border-box",
    justifyContent: "space-between",
    backgroundColor: "#fff", // optional, in case background overlay is needed
  },
  footerTitle: {
    fontFamily: "Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: "10px",
    lineHeight: "18px",
    color: "#76A3BE",
    textTransform: "uppercase",
    marginBottom: "5px",
  },
  description: {
    color: "#76A3BE",
    fontFamily: "Helvetica, sans-serif",
    fontWeight: 400,
    fontSize: "8px",
    lineHeight: "18px",
    maxWidth: "496px",
  },
  pageNumber: {
    fontFamily: "Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: "10px",
    lineHeight: "18px",
    color: "#76A3BE",
    alignSelf: "flex-start",
    marginTop: "10px",
  },
};

const HomeReflectAndIntegrate = ({ apiData, previewData, reportType, pageNumber }) => {
  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)", }}>
      <HeaderPreview apiData={apiData} />
      <div style={styles.pageWrapper}>
        <div style={styles.content}>
          <div style={styles.contentDescription}>
            <div style={styles.text}>REFLECTIONS</div>
            <img src={RelectAndIntegrate1Image} alt="Reflect and Integrate" style={styles.image} />
          </div>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>

  );
};

export default HomeReflectAndIntegrate;
